"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "getWeight", {
    enumerable: true,
    get: function() {
        return getWeight;
    }
});
function getWeight(target, weight, maxWorkers) {
    if (typeof weight === "number") {
        return weight;
    } else if (typeof weight === "function") {
        return weight(target, maxWorkers);
    }
    return 1;
}
